import React, { useEffect, useMemo } from 'react'
// import _ from 'lodash'
import { ComboBox } from '@sencha/ext-modern'
import { genFullListName, getMixedProps, useDelayHandleChange } from './blockPublic'
import { isEqual } from 'lodash'
import { useInstData } from '../../../hooks'

const handleValueChange = (name, currentValue, onChange, type) => (field, inputValue) => {
	// console.log('change')
	type == 'array' && !inputValue && (inputValue = [])
	// console.log('currentValue:', currentValue)
	// console.log('inputValue:', inputValue)
	// ComboBox调用onChange时尚未更新input显示值，在onChange事件中如果组件内容变化大时会激发focusLeave事件，
	// ComboBox中focusLeave事件处理时会比较input中的值inputValue(文本)及value，并以inputValue中值为准，不一致会调用syncValue同步数据并再次激发change事件。
	// onChange({ name, newValue: inputValue, type })
	!isEqual(currentValue, inputValue) && setTimeout(() => onChange({ name, newValue: inputValue, type }))
}

const FormSelect = ({ config: {
	field, onChange, initValues, /* changedValues,  */defaultStyle, that, that: { state: { _validStamp } }
} }) => {
	let { options: optionsProp, name, list, optionName, multiSelect } = field
	const optionsParas = { ...that.props.optionsParas, ...that.state.optionsParas }
	const fullName = genFullListName(list, name)
	const { props: { key, addInitValue, locale, ...mixedProps } } = getMixedProps('_select', [defaultStyle, field])
	const { value: currentValue } = mixedProps
	optionsProp = optionsProp || optionsParas[optionName || name] || []
	const { me } = useInstData()
	// options支持[['text', value], ...]
	// options 支持[{text:'', value:'', xxx:''}, ...]
	const { options, filter } = useMemo(() => {
		let options = optionsProp.length && Array.isArray(optionsProp[0]) ? optionsProp.map(([text, value]) => ({ text, value })) : optionsProp
		let filter = true
		options = options.map(o => o.text ? (locale ? { text: Tyan.t(o.text, locale), value: o.value } : o) : { text: locale ? Tyan.t(o, locale) : o, value: o })

		if (!options.length || Object.keys(options[0]).length <= 2) return { options, filter: true }

		options = options.map(o => (o.__searchstring = Object.values(o).join(', ').toLowerCase(), o))

		filter = {
			filterFn: function ({ data: { __searchstring = '' } = {} }) {
				let { _filterValue: v } = this
				return v ? __searchstring.includes(v.toLowerCase()) : true
			}
		}
		return { options, filter }
	}, [optionsProp, locale])

	const initValue = initValues && initValues[fullName]
	const added = addInitValue
		&& [].concat(initValue)
			.filter(v => v && !options.find(o => o.value == v))
			.map(value => ({ text: locale ? Tyan.t(value, locale) : value, value }))
		|| []
	multiSelect && delete mixedProps.forceSelection
	const handleChange = useDelayHandleChange(handleValueChange(field.name, currentValue, onChange, multiSelect ? 'array' : 'string'))

	useEffect(() => {
		_validStamp && me.cmp?.validate()
	}, [_validStamp])

	return <ComboBox {...mixedProps} queryMode='local' ref={ref => ref && (me.cmp = ref.cmp)}
		options={[...options, ...added]}
		primaryFilter={filter}
		onErrorChange={(field, error) => that.setState(state => ({ formErrorCount: (state.formErrorCount || 0) + (error ? 1 : -1) }))}
		onChange={handleChange}
	/>
}

const renderSelect = config => {
	const { key } = config.field || {}
	return <FormSelect key={key} config={config} />
}


export default renderSelect